import type { StoreWithDispatch } from '@ms/yammer-data';
import { realtimeLogger } from '@ms/yammer-data/dist/realtime/debugEventLog/middleware';
import createReduxStore from '@ms/yammer-data/dist/store/createStore';
import { i18nReducer } from '@ms/yammer-i18n-react';
import type { ReducersMapObject } from 'redux';
import type { YammerTeamsNativeState } from 'state/types';

import { persistConfig } from '../persistedState';

export type CreateStore = () => StoreWithDispatch<YammerTeamsNativeState>;

export const createStore: CreateStore = () => {
  const reducers: ReducersMapObject<Partial<YammerTeamsNativeState>> = {
    i18n: i18nReducer,
  };

  return createReduxStore<YammerTeamsNativeState>({
    reducers,
    persistConfig,
    middleware: [realtimeLogger],
  }).store;
};
